/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import ButtonGroup from '../../components/ProductDetailPage/components/ButtonGroup'
import { useUserData } from '../../contexts/UserDataContext'
import AddToCart from '../../components/ProductDetailPage/components/AddToCart'
import ProductPricesMobile from '../../functional-components/ProductPricesMobile'
import './index.css'

export const NewMobileAddToCartButtonPdpFirst = ({
  productQuantity,
  hit,
  discount,
  onRemoveOneFromCart,
  onAddToCartNew,
  colorUnit,
  button,
}) => {
  const mobileOptimize = document.cookie.includes('addToCartAB')
  const userData = useUserData()
  const soldByWeight = hit?.attributes?.soldByWeight

  useEffect(() => {
    if (mobileOptimize) {
      document.body.dataset.experimentMobileButtonAddtocart = 'true'
      userData.setData('addToCartAB', true)
    } else {
      userData.setData('addToCartAB', false)
    }
  }, [])
  return mobileOptimize && productQuantity > 0 ? (
    <div className="fixed-position-mobile-add-button d-flex">
      <div>
        <div className="price-container-mobile-add-button">
          <ProductPricesMobile price={hit.price} discount={discount} soldByWeight={soldByWeight} />
        </div>
        {button ? (
          button
        ) : (
          <ButtonGroup
            onAddToCart={(item) => onAddToCartNew(item, true)}
            onRemoveOneFromCart={onRemoveOneFromCart}
            hit={hit}
            productQuantity={productQuantity}
            colorUnit={colorUnit}
          />
        )}
      </div>
    </div>
  ) : null
}

const NewMobileAddToCartButtonPdp = ({
  productQuantity,
  hit,
  discount,
  makePublic,
  shouldRenderAddButton,
  onClick,
  button,
}) => {
  const mobileOptimize = document.cookie.includes('addToCartAB')
  const soldByWeight = hit?.attributes?.soldByWeight

  if (mobileOptimize && productQuantity === 0) {
    return (
      <div className="fixed-position-mobile-add-button d-flex">
        <div>
          <div className="price-container-mobile-add-button">
            <ProductPricesMobile price={hit.price} discount={discount} soldByWeight={soldByWeight} />
          </div>
          <div>
            {button ? (
              button
            ) : (
              <AddToCart disabled={!shouldRenderAddButton || !makePublic} onClick={() => onClick(hit, true)} />
            )}
          </div>
        </div>
      </div>
    )
  }
  return null
}

export default NewMobileAddToCartButtonPdp
